module.exports = __webpack_public_path__ + "static/media/event_uprising_pin.20cdc2c4.png";